var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 7",
    d: "M0.739119 9.92121C0.38901 10.2711 0.38901 10.8383 0.739119 11.1882C1.08923 11.538 1.65687 11.538 2.00697 11.1882L0.739119 9.92121ZM11.2378 1.59275C11.2378 1.09797 10.8364 0.69687 10.3413 0.696869L2.27272 0.696871C1.77759 0.696871 1.37621 1.09797 1.37621 1.59275C1.37621 2.08753 1.77759 2.48863 2.27272 2.48863L9.44479 2.48863L9.44479 9.65565C9.44479 10.1504 9.84617 10.5515 10.3413 10.5515C10.8364 10.5515 11.2378 10.1504 11.2378 9.65565L11.2378 1.59275ZM2.00697 11.1882L10.9752 2.22623L9.70737 0.959266L0.739119 9.92121L2.00697 11.1882Z",
    fill: "#6CE3C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow7);
export default __webpack_public_path__ + "static/media/Arrow 7.0c16d7cb54cfcf3377292102b8f79e42.svg";
export { ForwardRef as ReactComponent };